<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Nova operacija</h3>
    </div>
    <div class="card-body">
      <form [formGroup]="operationForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Operacija</label>
              <app-dropdown [options]="developmentOperationNames"
                            [parentForm]="operationForm" 
                            [parentControl]="'name'"></app-dropdown>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Dodeljeno (MIN)</label>
              <input type="text" class="form-control" mask="separator.2" thousandSeparator="." decimalMarker="," formControlName="timeEstimatedEmployee" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Komentar</label>
              <textarea class="form-control" name="comment" formControlName="comment" rows="1" maxlength="50"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="operationForm.invalid">Sačuvaj</button>
    </div>
  </div>
</div>
